<template>
  <div class="lots-list tab-table p-2">
    <relations-table :hide-action-buttons="true" :exclude-columns="['created_at', 'created_by',
    'updated_at', 'updated_by', 'intermediary_commission_from', 'related_customer_uuid']"
                     :exclude-search-fields="['related_customer_uuid']"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import LotsTable from "@/modules/lots/LotsTable.vue";
  import RelationsTable from "@/modules/relations/RelationsTable.vue";

  const {mapState} = createNamespacedHelpers('customer/customerView');
  const {mapActions: relationsMapActions} = createNamespacedHelpers('relations');

  export default {
    name: "RelatedToList",
    components: {LotsTable, RelationsTable},
    data() {
      return {}
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      })
    },
    methods: {
      ...relationsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'customerRelatedTo',
        extraFilters: {related_customer_uuid: this.customer.uuid},
        object: this.customer,
        extraExpands: 'related_object'
      })
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .btn-table-actions {
    display: none;
  }
</style>
